import { Input, InputNumber, InputRef } from 'antd';
import React, { forwardRef } from 'react';

import Icon, { IconName } from '../Icon';

interface InputCustomProps extends React.ComponentProps<typeof Input> {
  placeholder?: string;
  value: string | number;
  className?: string;
  containerClassName?: string;
  customHeight?: number;
  style?: React.CSSProperties;
  onChange?: (e?: any) => void;
  onKeyDown?: (e?: any) => void;
  onEnter?: (e?: any) => void;
  prefixIcon?: IconName;
  type?: string;
  errText?: string;
  disabled?: boolean;
  suffix?: React.ReactNode;
  readOnly?: boolean;
}

const InputCustom = forwardRef<InputRef, InputCustomProps>(
  (
    {
      placeholder,
      className,
      customHeight = 44,
      style,
      onChange,
      onEnter,
      onKeyDown,
      prefixIcon,
      type,
      errText,
      value,
      disabled,
      readOnly,
      containerClassName,
      ...props
    },
    ref
  ) => (
    <div className={`a-inputCustom${errText ? ' err' : ''} a-inputCustom-${readOnly ? 'readonly' : ''} ${containerClassName}`}>
      {type === 'number' ? (
        <InputNumber
          ref={ref as any}
          disabled={disabled}
          value={value as number}
          placeholder={placeholder}
          className={className}
          onChange={onChange}
          onKeyDown={(e) => {
            const invalidKeys = ['-', '.', ',', 'e', 'E', '+'];
            if (invalidKeys.includes(e.key)) {
              e.preventDefault();
            }
            onKeyDown?.(e);
          }}
          type="number"
          style={{
            width: '100%',
            height: customHeight,
            ...style,
          }}
          prefix={prefixIcon && <Icon iconName={prefixIcon} size="20" />}
          onPressEnter={onEnter}
          min={(props as any).min ?? 0}
          max={(props as any).max}
          precision={0}
          step={1}
          suffix={props.suffix}
          readOnly={readOnly}
        />
      ) : (
        <Input
          ref={ref}
          disabled={disabled}
          value={value}
          type={type}
          placeholder={placeholder}
          className={className}
          onChange={onChange}
          onKeyDown={onKeyDown}
          {...props}
          style={{
            height: customHeight,
            ...style,
          }}
          prefix={prefixIcon && <Icon iconName={prefixIcon} size="20" />}
          suffix={props.suffix}
          onPressEnter={onEnter}
          readOnly={readOnly}
        />
      )}

      {errText && <div className="a-inputCustom-errText">{errText}</div>}
    </div>
  )
);
export default InputCustom;
